import { Injectable } from '@angular/core';

@Injectable()
export class AppGlobals {
    public spa_id = '5e1440da95239';
}
